import {
  getWorkspaceAccountEvents,
  listWorkspaceSessions,
  listWorkspaceSessionToolCalls,
  streamWorkspaceAiActivity,
} from '../services/adminApi.js'
import { useEntityActivityLog, type UseEntityActivityLogResult } from './useEntityActivityLog.js'

const WORKSPACE_ACTIVITY_API = {
  getAccountEvents: getWorkspaceAccountEvents,
  listSessions: listWorkspaceSessions,
  listSessionToolCalls: listWorkspaceSessionToolCalls,
  streamActivity: streamWorkspaceAiActivity,
}

export function useWorkspaceActivityLog(workspaceId: string | null): UseEntityActivityLogResult {
  return useEntityActivityLog(workspaceId, WORKSPACE_ACTIVITY_API)
}
